export { default, MEDIA_WRAPPER_TAG, VcMediaWrapperProps } from './MediaWrapper';
